export const colors = {
    primary: "#4466F2",
    primarySkinColor: "#f8f8f8",
    secondarySkinColor: "#ffffff",
    textColor: '#313131',
    borderColor: '#ffffff',
    primaryColor: '#4466F2',
    navColor: '#4466F2',
    navTextColor:'rgba(255, 255, 255, 0.774)',

    sidebar_background : '#4466F2',
		sidebar_color: '#4466F2',
		sidebar_icons_background: '#4466F2',  
		sidebar_icon_color: '#4466F2',
		nav_background: '#4466F2',
		nav_color: '#4466F2',

  };


